import { TextField } from '@material-ui/core'
import React from 'react'

import { titleInputStyles } from '../../styles/InputStyles'

type Props = {
    error?: boolean
    label?: string;
    underText?: string;
    type?: string;
    onChange?: (value: any) => void;
    onSubmit?(): void;
    onBlur?(): void;
    value?: string;
    onKeyPress?: (value: string, event: React.KeyboardEvent<HTMLDivElement>) => void
    fullWidth?: boolean,
    disabled?: boolean,
    required?: boolean,
    helperText?: string
}

export const TitleInput: React.FC<Props> = ({
    error,
    label,
    underText,
    helperText,
    type,
    onChange,
    onKeyPress,
    onSubmit,
    onBlur,
    value,
    fullWidth,
    disabled,
    required
}) => {

    const styles = titleInputStyles()

    const actuallyError = error && !!value && value.length > 0
    const rejectedFieldMessage = (helperText && actuallyError) ? helperText : ''
    return (
        <form className={styles.container} noValidate autoComplete="off">
            <TextField
                error={actuallyError}
                onChange={(e) => onChange && onChange(e.target.value)}
                onSubmit={onSubmit}
                onKeyPress={(e) => onKeyPress && onKeyPress(e.key, e)}
                onBlur={onBlur}
                label={label}
                fullWidth={fullWidth}
                value={value}
                disabled={disabled}
                required={required}
                variant="outlined"
                helperText={rejectedFieldMessage || (actuallyError ? 'Invalid value' : '')}
                type={type}
                InputLabelProps={{
                    classes: {
                        root: styles.cssLabel,
                        focused: styles.cssFocused,
                    },
                }}
                InputProps={{
                    classes: {
                        root: styles.cssOutlinedInput,
                        focused: styles.cssFocused,
                        notchedOutline: styles.notchedOutline,

                    }
                }}/>
            <small>{underText}</small>
        </form>
    )
}

TitleInput.defaultProps = {
    error: false,
    label: '',
    underText: '',
    type: '',
    onChange: undefined,
    onSubmit: undefined,
    onBlur: undefined,
    value: '',
    fullWidth: false,
    disabled: false,
    required: false,
    helperText: '',
    onKeyPress: undefined
}
